import { Component, Input } from '@angular/core'
import { User } from '@ftr/contracts/api/user'

@Component({
  selector: 'ftr-user-profile-details',
  templateUrl: './user-profile-details.component.html',
})
export class UserProfileDetailsComponent {
  @Input() user: User
}
